"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeDefinition = void 0;
var _material = require("@mui/material");
const themeDefinition = exports.themeDefinition = {
  palette: {
    primary: {
      light: '#9b9b9b',
      main: '#003B5C',
      dark: '#000',
      contrastText: '#fff'
    },
    secondary: {
      light: '#ddedfa',
      main: '#4FC3F7',
      dark: '#757575',
      contrastText: '#fff'
    },
    error: {
      light: '#9b9b9b',
      main: '#a6182d',
      dark: '#4a4a4a',
      contrastText: '#757575'
    },
    accent: {
      light: '#acd3d8',
      main: '#128192',
      dark: '#0c5a65',
      contrastText: '#fff'
    },
    navigationTextColor: '#fff',
    text: {
      hint: 'rgba(0, 0, 0, 0.38)'
    }
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          [`&.${_material.accordionClasses.expanded}`]: {
            margin: 0
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: ({
          theme
        }) => ({
          [`&.${_material.accordionSummaryClasses.expanded}`]: {
            minHeight: theme.spacing(6)
          }
        }),
        content: ({
          theme
        }) => ({
          [`&.${_material.accordionSummaryClasses.expanded}`]: {
            margin: [theme.spacing(1.5, 0)]
          }
        })
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        listbox: {
          '& ul': {
            padding: 0,
            margin: 0
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          [`&.${_material.checkboxClasses.checked}`]: {
            color: '#4FC3F7'
          }
        }
      }
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined'
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiList: {
      styleOverrides: {
        dense: {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        MenuListProps: {
          dense: true
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined',
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          }
        }
      }
    },
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        hover: {
          backgroundColor: '#f5f5f5'
        },
        root: {
          [`&.${_material.tableRowClasses.selected}`]: {
            backgroundColor: '#B3E5FC !important'
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined'
      }
    }
  },
  snackbarAutoHideDuration: 3500
};
//# sourceMappingURL=calabrio.js.map